/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UnproxiedMcpServer,
  UnproxiedMcpServer$inboundSchema,
} from "./unproxiedmcpserver.js";

/**
 * Result type for listing unproxied MCP servers
 */
export type ListUnproxiedMcpServersResult = {
  unproxiedMcpServers: Array<UnproxiedMcpServer>;
};

/** @internal */
export const ListUnproxiedMcpServersResult$inboundSchema: z.ZodMiniType<
  ListUnproxiedMcpServersResult,
  unknown
> = z.pipe(
  z.object({
    unproxied_mcp_servers: z.array(UnproxiedMcpServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "unproxied_mcp_servers": "unproxiedMcpServers",
    });
  }),
);

export function listUnproxiedMcpServersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUnproxiedMcpServersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUnproxiedMcpServersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUnproxiedMcpServersResult' from JSON`,
  );
}
